import { cn } from "../lib/cn";

export type SpinnerProps = {
  className?: string;
  size?: "sm" | "md" | "lg";
  label?: string;
};

const sizeClass = {
  sm: "h-4 w-4 border-2",
  md: "h-5 w-5 border-2",
  lg: "h-7 w-7 border-[3px]",
} as const;

export function Spinner({
  className,
  size = "md",
  label = "Laddar",
}: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn(
        "inline-block animate-spin rounded-full border-current border-t-transparent opacity-80",
        sizeClass[size],
        className
      )}
    />
  );
}
